// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2lzZZ","title":"Info_title__OKdvU","selects":"Info_selects__2qXbg","requiredAsterisk":"Info_requiredAsterisk__2r-DS"};